import React from 'react'
import PropTypes from 'prop-types'

// @material-ui
import { makeStyles } from '@material-ui/core/styles'

// core
import { withCatch } from '_core/hocs/withCatch'
import { withLang } from '_core/hocs/withLang'

import { useGlobal } from '_core/hooks/useGlobal'

import { withVisitorInfo } from '_core/utils/visitorInfo'

import { PopupMessage } from 'basic/views/PopupMessage'

import { Title } from '_core/components/Title'


const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

const RawPopupMessages = (props) => {
  const { visitorInfo, getLangString: l } = props

  const {
    request: { queue },
    config: { API_METHOD, DASHBOARD_MESSAGES_SHOW_LIMIT },
    notify: { enqueueSnackbar }
  } = useGlobal();

  const classes = useStyles();

  const handleMessageRead = (message) => {
    const messageIds = [ message.id ];
    queue(API_METHOD.VISITOR_MESSAGE_HAD_READ, { "message_ids": messageIds }, RawPopupMessages.displayName)
      .then(() => {
        message.isRead = true;
        visitorInfo.messagesHadRead(messageIds);
      }).catch((error) => {
        enqueueSnackbar(error.message, { variant: 'error' });
      });
  }

  const data = visitorInfo
    .listPopupMessages()
    .sort((a, b) => a.timestamp.getTime() < b.timestamp.getTime())
    .slice(0, DASHBOARD_MESSAGES_SHOW_LIMIT);
  
  if (data.length > 0) {
    return (
      <div className={classes.root}>
        <Title icon="equalizer" children={l('r._.popup.messages.text.title')} />
        {
          data.map((message) => {
            return (
              <PopupMessage key={message.id} message={message} onClose={() => handleMessageRead(message)} />
            );
          })
        }
      </div>
    );
  } else {
    return null;
  }
}

RawPopupMessages.defaultProps = {}

RawPopupMessages.propTypes = {
  // self props
  message: PropTypes.object,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const PopupMessages = withCatch(
  withVisitorInfo(
    withLang(
      (RawPopupMessages)
    )
  )
)
